import groq from 'groq';
import { ComponentType, EntityType, MiscTypes } from '../../types';
import { TagsFragment } from '../components/tags';
import { PageHierarchyItemsFragment, PosterFragment, TextComponentFragment } from '../components';
import { CardContentFragment, CardContentLiteFragment } from '../components/cardContent';

const CardNewsPostFragment = groq`
  ...,
  summary,
  name,
  publicationInfo,
  _type == "${EntityType.NewsBasicPost}" => {
    ${TextComponentFragment}
  },
  ${TagsFragment},
  ${PosterFragment},
  ${CardContentLiteFragment}
`;

export const CardContentResolver = groq`
  _type == "${EntityType.NewsPost}" || _type == "${EntityType.NewsBasicPost}" => {
    slug,
    ${CardNewsPostFragment}
  },
  _type == "${EntityType.Page}" => {
    slug,
    ${PageHierarchyItemsFragment},
    name,
    ${CardContentFragment}
  },
  _type == "${MiscTypes.Document}" => {
    slug,
    name,
    ${CardContentFragment}
  },
  _type == "${MiscTypes.ExternalContent}" => {
    name,
    url,
    ${CardContentFragment}
  }
`;

export const NewsCardFragment = groq`
  ...,
  defined(content) => {
    content->{
      _id,
      _type,
      slug,
      name,
      ${CardContentResolver}
    }
  }
`;

export const NewsCardSectiontResolver = groq`
  _type == "${ComponentType.NewsCard}" => {
    ...,
    ${NewsCardFragment}
  }
`;

export const GetAutomatedCardsQueryWithPages = groq`
  *[
    ((_type == "${EntityType.NewsPost}" || _type == "${EntityType.NewsBasicPost}") && ((length($tags) == 0) || count((tags[]._ref)[@ in $tags]) > 0) && !(_id in $ids)) || 
    (_type in ["${MiscTypes.Document}", "${EntityType.Page}", "${MiscTypes.ExternalContent}"] && ((length($tags) == 0) || (count((cardContent.content.tags[]._ref)[@ in $tags]) > 0)) && cardContent.includeInAutomatedCards && !(_id in $ids))
  ]{
    _id,
    _type,
    name,
    "sortDate": select(
      defined(publicationInfo) => publicationInfo.publicationDate,
      defined(cardContent) => cardContent.content.publicationDate,
      _updatedAt
    ),
    ${CardContentResolver}
  } | order(sortDate desc, _id desc)[0...$limit]
`;

export const GetNewsCardById = groq`
  *[_type == "${ComponentType.NewsCard}" && _id == $id]{
    ${NewsCardFragment}
  }[0]  
`;
